import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import Collapse from '@mui/material/Collapse';

import { ParamsDataFinancialPending } from 'utils/typeServices';
import { HandleParseLinkNf } from 'utils/parseLinkNf';

import { Button, Typography } from '@mui/material';
import { ModalPaymentMethodTicket, ModalPaymentMethodTicketConfirm } from 'components/views/Invoices/Modals';

import { ButtonCustom, TypographyLabel, TypographyText, ContainerRowNav } from './styles';

type Params = {
    typeInvoice: 'nextInv' | 'overdueInv' | 'paidInv';
    invDetailsList: Array<ParamsDataFinancialPending>;
}

type ParamsDetails = {
    DueDate: string;
    PayValue: string;
    OriginValue: string;
    Plate: string;
    TaxReceipt: string;
    Service: string;
    Company: string;
    CurrentPaymentMethod: string;
    typeInvoice: string;
    showBorder: boolean;
    NFENumber: string;
    Status: number;
    InscMunicipalNumber: string;
    NFEVerificationNumber: string;
    PaymentMethodTypeId: number;
    CHAVE_PAGAMENTO: string;
    CD_FORMA_PAGAMENTO: number;
}

const ContentDetails = ({ DueDate, PaymentMethodTypeId, PayValue, OriginValue, Plate, TaxReceipt, Service, Company, CurrentPaymentMethod, typeInvoice, showBorder, NFENumber, InscMunicipalNumber, NFEVerificationNumber, Status, CHAVE_PAGAMENTO, CD_FORMA_PAGAMENTO }: ParamsDetails) => {
    const navigate = useNavigate();
    const [showModalPaymentMethodTicket, setShowModalPaymentMethodTicket] = useState(false);
    const [showModalPaymentMethodTicketConfirm, setShowModalPaymentMethodTicketConfirm] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const handlePayInvoice = () => {
        if (PaymentMethodTypeId !== 22) {
            navigate('pagamento', {
                state: {
                    CHAVE_PAGAMENTO: CHAVE_PAGAMENTO,
                    CD_FORMA_PAGAMENTO: CD_FORMA_PAGAMENTO,
                }
            });
        } else {
            setShowModalPaymentMethodTicket(true);
        }
    }

    return (
        <>
            <Box>
                <Box sx={{
                    margin: '0 -7px',
                    padding: '.2rem .75rem',
                    borderRadius: '5px',
                    backgroundColor: typeInvoice === 'overdueInv' ? 'rgba(255, 0, 0, 0.1)' : 'transparent'
                }}>
                    <ContainerRowNav>
                        <Box>
                            <TypographyLabel>
                                Vencimento
                            </TypographyLabel>
                            <TypographyText fontWeight={400} paddingTop='.25rem'>
                                {DueDate}
                            </TypographyText>
                        </Box>
                        <Box>
                            <TypographyLabel>
                                Valor atualizado
                            </TypographyLabel>
                            <Typography variant='subtitle2' fontWeight={700} paddingTop='.25rem'>
                                {PayValue ? PayValue : ''}
                            </Typography>
                            {typeInvoice === 'overdueInv' &&
                                <Typography fontSize='.5625rem' lineHeight='.7rem' paddingTop='.2rem'>
                                    Valor original - {OriginValue}
                                </Typography>
                            }
                        </Box>
                        <Box>
                            {((typeInvoice === 'paidInv') || (Status === 3)) ?
                                <Box sx={{
                                    minWidth: '5rem'
                                }} />
                                :
                                <ButtonCustom
                                    variant='contained'
                                    color='secondary'
                                    sx={{
                                        width: '7.125rem',
                                        height: '2.1875rem'
                                    }}
                                    onClick={() => PaymentMethodTypeId === 22 ? setShowModalPaymentMethodTicket(true) : handlePayInvoice()}
                                    disabled={(CHAVE_PAGAMENTO && (CD_FORMA_PAGAMENTO !== undefined)) ? false : true}
                                >
                                    PAGAR AGORA
                                </ButtonCustom>
                            }
                        </Box>
                    </ContainerRowNav>
                    <Box>
                        <Collapse in={showDetails}>
                            <ContainerRowNav>
                                <Box>
                                    <TypographyLabel>
                                        Placa
                                    </TypographyLabel>
                                    <TypographyText fontWeight={400} paddingTop='.25rem'>
                                        {Plate}
                                    </TypographyText>
                                </Box>
                                <Box>
                                    <TypographyLabel>
                                        Periodo
                                    </TypographyLabel>
                                    <TypographyText fontWeight={400} paddingTop='.25rem'>
                                        {TaxReceipt}
                                    </TypographyText>
                                </Box>
                                <Box>
                                    <TypographyLabel>
                                        Forma de pagamento
                                    </TypographyLabel>
                                    <TypographyText fontWeight={400} paddingTop='.25rem'>
                                        {CurrentPaymentMethod}
                                    </TypographyText>
                                </Box>
                            </ContainerRowNav>
                            <ContainerRowNav>
                                <Box>
                                    <TypographyLabel>
                                        Serviços
                                    </TypographyLabel>
                                    <TypographyText fontWeight={400} paddingTop='.25rem' textTransform='capitalize'>
                                        {Service?.toLowerCase()}
                                    </TypographyText>
                                </Box>
                                <Box>
                                    <TypographyLabel>
                                        Tipo de Cobrança
                                    </TypographyLabel>
                                    <TypographyText fontWeight={400} paddingTop='.25rem' textTransform='capitalize'>
                                        {Company?.toLowerCase()}
                                    </TypographyText>
                                </Box>
                                <Box>
                                    {Status !== 3 &&
                                        <ButtonCustom sx={{
                                            border: '1px solid #0C1C33',
                                            width: '7.125rem',
                                            height: '2.1875rem'
                                        }}
                                            onClick={() => window.open(HandleParseLinkNf({ NFENumber: NFENumber, InscMunicipalNumber: InscMunicipalNumber, NFEVerificationNumber: NFEVerificationNumber }), '_blank')}
                                        >
                                            NOTA FISCAL
                                        </ButtonCustom>
                                    }
                                </Box>
                            </ContainerRowNav>
                        </Collapse>
                        <Box sx={{
                            display: 'flex',
                            position: 'relative',
                            alignItems: 'center',
                            margin: `1.4rem 0 ${typeInvoice !== 'overdueInv' ? '.4rem' : '0'}`,
                            justifyContent: 'center',
                            borderBottom: typeInvoice !== 'overdueInv' ? '1px solid rgba(141, 155, 181, 0.35)' : 'none'
                        }}>
                            <Button sx={{
                                width: '3.875rem',
                                height: '1.25rem',
                                paddingTop: '8px',
                                fontSize: '.5625rem',
                                borderRadius: '10px',
                                border: '1px solid #8D9BB5',
                                position: 'absolute',
                                backgroundColor: 'white',
                                '&:hover': {
                                    backgroundColor: 'white',
                                }
                            }}
                                onClick={() => setShowDetails(!showDetails)}
                            >
                                {showDetails ? 'FECHAR' : 'DETALHES'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
                {typeInvoice === 'overdueInv' && showBorder &&
                    <Box sx={{
                        width: '98%',
                        margin: '0 auto',
                        padding: '1.75rem 0 .875rem'
                    }}>
                        <Box sx={{
                            width: '100%',
                            height: '1px',
                            backgroundColor: 'rgba(141, 155, 181, 0.35)',
                        }} />
                    </Box>
                }
            </Box>

            <ModalPaymentMethodTicket open={showModalPaymentMethodTicket} handleClick={(e) => {
                if (e) {
                    setShowModalPaymentMethodTicketConfirm(e);
                }
                setShowModalPaymentMethodTicket(false);
            }} />
            <ModalPaymentMethodTicketConfirm open={showModalPaymentMethodTicketConfirm} handleClick={(e) => {
                if (e) {
                    navigate('pagamento', {
                        state: {
                            CHAVE_PAGAMENTO: CHAVE_PAGAMENTO,
                            CD_FORMA_PAGAMENTO: CD_FORMA_PAGAMENTO,
                        }
                    });
                }
                setShowModalPaymentMethodTicketConfirm(false);
            }} />
        </>
    );
}

const TableMobile = ({ invDetailsList, typeInvoice }: Params) => {
    return (
        <Box sx={{
            display: {
                xs: 'block',
                md: 'none'
            }
        }}>
            {invDetailsList?.length === 0 &&
                <Typography
                    fontSize='1rem'
                    fontWeight={700}
                    paddingTop='1.75rem'
                    color={typeInvoice === 'nextInv' ? '#0AA8E3' : typeInvoice === 'overdueInv' ? '#FF0000' : '#97C93D'}
                >
                    Sem faturas disponíveis
                </Typography>
            }
            {invDetailsList?.map(({ DT_VENCIMENTO, DS_PLACA, NM_PRODUTO, DT_PERIDO_FIM, DT_PERIODO_INICIO, NM_TIPO_COBRANCA, VL_ATUALIZADO, VL_ORIGINAL, NM_FORMA_PGTO, NUM_NFE, NR_INSC_MUN, COD_VERIF_NFE, ID_FORMA_PGTO, NR_STATUS, CD_FORMA_PAGAMENTO, CHAVE_PAGAMENTO }, index) =>
                <ContentDetails
                    key={index}
                    DueDate={DT_VENCIMENTO}
                    PayValue={VL_ATUALIZADO}
                    OriginValue={VL_ORIGINAL}
                    Plate={DS_PLACA}
                    TaxReceipt={`${new Date(DT_PERIODO_INICIO).toLocaleDateString('pt-BR')} até ${new Date(DT_PERIDO_FIM).toLocaleDateString('pt-BR')}`}
                    Service={NM_PRODUTO}
                    Company={NM_TIPO_COBRANCA}
                    CurrentPaymentMethod={NM_FORMA_PGTO}
                    typeInvoice={typeInvoice}
                    showBorder={index !== (invDetailsList?.length - 1)}
                    NFENumber={NUM_NFE}
                    Status={NR_STATUS}
                    InscMunicipalNumber={NR_INSC_MUN}
                    NFEVerificationNumber={COD_VERIF_NFE}
                    PaymentMethodTypeId={ID_FORMA_PGTO}
                    CHAVE_PAGAMENTO={CHAVE_PAGAMENTO}
                    CD_FORMA_PAGAMENTO={CD_FORMA_PAGAMENTO}
                />
            )}
        </Box >
    );
}

export default TableMobile;